<template>
  <div>
    <h5 class="text-center">Where did you get this product?</h5>
    <div class="row">
      <div class="col-md-10 col-md-offset-1">
        <div class="form-group">
          <label class="control-label">Website URL</label>
          <input class="form-control"
                 type="text"
                 name="websiteUrl"
                 v-validate="modelValidations.websiteUrl"
                 v-model="model.websiteUrl"
                 url="true"
                 placeholder="ex: https://www.ebay.com"
          />
          <small class="text-danger" v-show="websiteUrl.invalid">
            {{ getError('websiteUrl') }}
          </small>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-5 col-md-offset-1">
        <div class="form-group">
          <label class="control-label">Seller/Store Name</label>
          <input class="form-control"
                 type="text"
                 name="sellerName"
                 placeholder="Seller username or name of physical store"
                 v-validate="modelValidations.sellerName"
                 v-model="model.sellerName"
          />
          <small class="text-danger" v-show="sellerName.invalid">
            {{ getError('sellerName') }}
          </small>
        </div>
      </div>
      <div class="col-md-5">
        <div class="form-group">
          <label class="control-label">
            City
          </label>
          <input class="form-control"
                 type="text"
                 name="sellerCity"
                 v-model="model.sellerCity"
          />
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-5 col-md-offset-1">
        <div class="form-group">
          <label class="control-label">
            State
          </label>
          <input class="form-control"
                 type="text"
                 name="sellerState"
                 v-model="model.sellerState"
          />
        </div>
      </div>
      <div class="col-md-5">
        <div class="form-group">
          <label class="control-label">Country</label>
          <input class="form-control"
                 type="text"
                 name="sellerCountry"
                 v-model="model.sellerCountry"
                 placeholder="ex: USA"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import {mapFields} from 'vee-validate'

  export default {
    computed: {
      ...mapFields(['websiteUrl', 'sellerName', 'sellerCity', 'sellerState', 'sellerCountry'])
    },
    data () {
      return {
        model: {
          websiteUrl: '',
          sellerName: '',
          sellerCity: '',
          sellerState: '',
          sellerCountry: ''
        },
        modelValidations: {
          websiteUrl: {
            url: true
          },
          sellerName: {
            required: true
          }
        }
      }
    },
    methods: {
      getError (fieldName) {
        return this.errors.first(fieldName)
      },
      validate () {
        return this.$validator.validateAll()
      }
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/FraudReport/Wizard/SecondStep.vue